module.exports = __webpack_public_path__ + "img/file-arrow-up.187d01d2.svg";